import { blogPosts } from "@nls-2022/nls-api/src/apiConsts";
import {
  FACompBlogContentType,
  BlogGenericContentType,
  BlogContentType,
} from "../../types/blog/blogContentTypes";
import {
  generateTitle,
  initBlogPostContent,
} from "./generateBlogPostContentUtils";
import {
  getFACompByType,
  getSponsorBySponsorName,
} from "../filters/filterPostsRefData";
import { formatDate } from "../../common/utils";
export const generateBlogPostContentFromCompBlogPost = (
  compBlogPost: FACompBlogContentType | undefined
): BlogGenericContentType => {
  if (compBlogPost === undefined) return initBlogPostContent();
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const sponsor = getSponsorBySponsorName(
    getFACompByType(compBlogPost!.comp)!.sponsorName
  );
  const roundDate = new Date(compBlogPost.roundDate);
  const today = new Date();

  let roundDateString =
    roundDate.getDate().toString() +
    " " +
    months[roundDate.getMonth()] +
    " " +
    roundDate.getFullYear().toString();
  const season: string =
    compBlogPost.season === undefined ? "" : compBlogPost.season;
  const title: string = undefined
    ? ""
    : getFACompByType(compBlogPost!.comp)!.name +
      " " +
      compBlogPost.roundName +
      " " +
      compBlogPost.title;
  const excerpt: string = undefined
    ? ""
    : "The " +
      compBlogPost.roundName +
      " of the " +
      compBlogPost.season +
      " " +
      sponsor!.sponsorName +
      " " +
      getFACompByType(compBlogPost!.comp)!.name +
      " takes place the weekend of Saturday " +
      roundDateString;
  const loserString = `${
    compBlogPost.loserPrizeMoney !== null
      ? "and the loser receiving £" + compBlogPost.loserPrizeMoney
      : ""
  }`;
  const otherTextString = `${
    compBlogPost.otherText !== "" ? "<p>" + compBlogPost.otherText + "</p>" : ""
  }`;
  const content = `<p>The ${compBlogPost.roundName} of the ${
    compBlogPost.season
  } 
    <a href='${sponsor!.sponsorUrl}' _target='blank'>${
    sponsor!.sponsorName
  }</a> ${getFACompByType(compBlogPost!.comp)!.name}
    takes place the weekend of Saturday ${roundDateString} 
    </p><p>
    The round consists of 
    ${compBlogPost.noOfTies} 
    ties with the winner receiving £${compBlogPost.winnerPrizeMoney}
    ${loserString}
    <br>   
    </p>
    ${otherTextString}
    `;

  let blogPostContent: BlogContentType = {
    season: season,
    isPublished: compBlogPost.isPublished,
    pubDate: compBlogPost.pubDate,
    createDate: formatDate(today.toDateString()),
    modifiedDate: formatDate(today.toDateString()),
    title: generateTitle(season, title).trim(),
    excerpt: excerpt,
    categories: compBlogPost.categories,
    content: content,
  };
  return blogPostContent;
};
